// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cinema_wrapper__tpr7w","movies":"Cinema_movies__Cp5nt","filters":"Cinema_filters__u5wJx","header":"Cinema_header__t2xiy","services":"Cinema_services__PdtsL"};